"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withGlobalNotification = exports.GlobalNotificationProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Notifications = _interopRequireDefault(require("./Notifications"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GlobalNotification = _react["default"].createContext({
  notifications: [],
  dispatchNotification: function dispatchNotification() {}
});

var GlobalNotificationProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(GlobalNotificationProvider, _Component);

  function GlobalNotificationProvider(props) {
    var _this;

    _classCallCheck(this, GlobalNotificationProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GlobalNotificationProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "dispatchNotification", function (_ref) {
      var icon = _ref.icon,
          id = _ref.id,
          message = _ref.message,
          timeout = _ref.timeout,
          title = _ref.title,
          type = _ref.type;
      if (_this.state.notifications.find(function (notification) {
        return notification.id === id;
      })) return null; // Assign a unique id to the notification if it wasn't passed in

      if (!id) {
        id = new Date().getTime();
      } // Set up timer to automatically dismiss notification after given time


      var notificationExpires = timeout || 6000;

      if (notificationExpires) {
        setTimeout(function () {
          return _this.expireNotification(id);
        }, notificationExpires);
      } // Clone the existing state, add the new notification to the end of the array


      var update = _toConsumableArray(_this.state.notifications).concat([{
        icon: icon,
        id: id,
        message: message,
        timeout: notificationExpires,
        title: title,
        type: type || "warning"
      }]);

      _this.setState({
        notifications: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "expireNotification", function (id) {
      // Clone the existing state, find the expiring notification and filter it out
      var update = _toConsumableArray(_this.state.notifications).filter(function (notification) {
        return notification.id !== id;
      });

      _this.setState({
        notifications: update
      });
    });

    _this.state = {
      notifications: []
    };
    return _this;
  }

  _createClass(GlobalNotificationProvider, [{
    key: "render",
    value: function render() {
      var notifications = this.state.notifications;
      return _react["default"].createElement(GlobalNotification.Provider, {
        value: {
          notifications: notifications,
          dispatchNotification: this.dispatchNotification
        }
      }, _react["default"].createElement(_Notifications["default"], {
        notifications: notifications
      }), this.props.children);
    }
  }]);

  return GlobalNotificationProvider;
}(_react.Component);

exports.GlobalNotificationProvider = GlobalNotificationProvider;

var withGlobalNotification = function withGlobalNotification(Component) {
  return function (props) {
    return _react["default"].createElement(GlobalNotification.Consumer, null, function (globalContext) {
      return _react["default"].createElement(Component, _extends({}, globalContext, props));
    });
  };
};

exports.withGlobalNotification = withGlobalNotification;